<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-main class="manage-user-container">
    <v-container fluid fill-height>
      <v-layout justify-center align-center mb-5 mt-5>
        <v-card width="100%">
          <v-card-title>{{ $t("manageYieldStaff.title") }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-flex xs12>
              <v-toolbar flat style="margin-top: 20px">
                <v-toolbar-title>{{ $t('manageYieldStaff.admins') }}</v-toolbar-title>
              </v-toolbar>
              <v-data-table
                :headers="headers"
                :items="admins">
                <template v-slot:item="props">
                  <tr>
                    <td class="text-sm-center">
                      <v-icon v-if="props.item.enabled" color="success">check_circle</v-icon>
                      <v-icon v-if="!props.item.enabled" color="error">lens</v-icon>
                    </td>
                    <td class="text-sm-left">{{ props.item.id }}</td>
                    <td class="text-sm-left">{{ props.item.firstName }}</td>
                    <td class="text-sm-left">{{ props.item.lastName }}</td>
                    <td class="text-sm-left">{{ props.item.username }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
            <v-flex xs12>
              <v-toolbar flat style="margin-top: 20px">
                <v-toolbar-title>
                  {{ $t('manageYieldStaff.moderators') }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  :label="$t('manageYieldStaff.search')"
                  single-line
                  hide-details></v-text-field>
              </v-toolbar>
              <v-data-table
                :headers="modHeaders"
                :items="moderators"
                :search="search">
                <template v-slot:item="props">
                  <tr>
                    <td class="text-sm-center">
                      <v-icon v-if="props.item.enabled" color="success">check_circle</v-icon>
                      <v-icon v-if="!props.item.enabled" color="error">lens</v-icon>
                    </td>
                    <td class="text-sm-left">{{ props.item.id }}</td>
                    <td class="text-sm-left">{{ props.item.firstName }}</td>
                    <td class="text-sm-left">{{ props.item.lastName }}</td>
                    <td class="text-sm-left">{{ props.item.username }}</td>
                    <td>
                      <v-switch color="success" v-model="props.item.enabled" @change="toggleUserActive(props.item)"></v-switch>
                    </td>
                  </tr>
                </template>
                <template slot="no-results">
                  <v-alert class="pa-2 text-xs-left" :value="true" color="error" icon="warning">
                    {{ $t('noResult') }}
                  </v-alert>
                </template>
              </v-data-table>
            </v-flex>
            <v-flex xs12 class="text-sm-left">
              <v-btn color="primary" outlined @click="dialog = true"
                     style="margin-left: 0;">
                <v-icon left>person_add</v-icon>
                {{ $t('manageYieldStaff.create') }}
              </v-btn>
            </v-flex>
          </v-card-text>
        </v-card>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <h3 style="margin-bottom: 10px;">{{ $t('manageYieldStaff.create') }}</h3>
            </v-card-title>
            <v-card-text>
              <v-divider></v-divider>
              <v-form v-model="form" ref="form" lazy-validation>
                <v-flex xs12 class="text-xs-left">
                  <v-text-field
                    color="primary"
                    :label="$t('contact.firstName')"
                    :rules="rules"
                    v-model="moderator.firstName"
                    required></v-text-field>
                  <v-text-field
                    color="primary"
                    :label="$t('contact.lastName')"
                    :rules="rules"
                    v-model="moderator.lastName"
                    required></v-text-field>
                  <h3 style="margin-top: 10px; text-align: left">Anmeldedaten:</h3>
                  <v-text-field
                    color="primary"
                    :label="$t('contact.email')"
                    :rules="rules"
                    v-model="moderator.username"
                    required></v-text-field>
                  <v-text-field
                    color="primary"
                    :label="$t('profile.password')"
                    :rules="rules"
                    v-model="moderator.password"
                    required></v-text-field>
                </v-flex>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" text @click.native="dialog = false">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" :loading="loading" :disabled="loading" @click="submit()">{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar
          :color="snackbar.result"
          v-model="snackbar.value"
          :bottom="true"
          :timeout="snackbar.timeout">
          {{ snackbar.text }}
          <v-btn
            color="white"
            text
            @click="snackbar.value = false">
            {{$t("close")}}
          </v-btn>
        </v-snackbar>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
  export default {
    name: 'manageUser',
    data() {
      return {
        search: '',
        snackbar: {
          result: 'success',
          timeout: 6000,
          value: false,
          text: ''
        },
        form: undefined,
        dialog: false,
        loading: false,
        moderator: {
          firstName: undefined,
          lastName: undefined,
          username: undefined,
          password: undefined
        },
        rules: [
          v => !!v || this.$i18n.t('form.required')
        ],
        admins: [],
        moderators: [],
        headers: [
          { text: false, align: 'center', sortable: false, value: false },
          { text: 'ID', align: 'left', value: 'id' },
          { text: this.$i18n.t('contact.firstName'), align: 'left', value: 'firstName' },
          { text: this.$i18n.t('contact.lastName'), align: 'left', value: 'lastName' },
          { text: this.$i18n.t('contact.email'), align: 'left', value: 'username' }
        ],
        modHeaders: [
          { text: false, align: 'center', sortable: false, value: false },
          { text: 'ID', align: 'left', value: 'id' },
          { text: this.$i18n.t('contact.firstName'), align: 'left', value: 'firstName' },
          { text: this.$i18n.t('contact.lastName'), align: 'left', value: 'lastName' },
          { text: this.$i18n.t('contact.email'), align: 'left', value: 'username' },
          { text: this.$i18n.t('manageYieldStaff.actions'), align: 'left', value: 'enabled' }
        ]
      };
    },
    mounted() {
      this.fetchData();
    },
    methods: {
      fetchData() {
        this.$http.get('users/admins')
          .then((body) => { this.admins = body.data; });
        this.$http.get('users/moderators')
          .then((body) => { this.moderators = body.data; });
      },
      submit() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.$http.post('users', this.moderator)
            .then(
              (body) => {
                this.moderators.push(body.data);
                this.dialog = false;
                this.$refs.form.reset();
                this.loading = false;
                this.snackbar.result = 'success';
                this.snackbar.text = this.$i18n.t('success');
                this.snackbar.value = true;
              },
            );
        }
      },
      toggleUserActive(moderator) {
        if (moderator.enabled) {
          this.$http.get('users/'.concat(moderator.id).concat('/activate'));
        } else {
          this.$http.get('users/'.concat(moderator.id).concat('/deactivate'));
        }
      }
    }
  };
</script>

<style lang="scss">
  .manage-user-container {
    .v-messages {
      display: none;
    }
  }
</style>
